import Autocomplete from '@mui/material/Autocomplete'
import { default as MuiTextField } from '@mui/material/TextField'

export const SelectFilter = ({
  id,
  options,
  loading,
  loadingText,
  value,
  onChange,
  getOptionLabel,
  label,
  style = { width: '80%' },
  size = 'small',
}) => {
  return (
    <Autocomplete
      id={id}
      key={value}
      size={size}
      options={options}
      style={style}
      loading={loading}
      loadingText={loadingText}
      value={value}
      onChange={onChange}
      getOptionLabel={getOptionLabel}
      renderInput={(params) => (
        <MuiTextField size={size} {...params} label={label} />
      )}
    />
  )
}
